import type { CustomCSSProperties } from "shared/util/style";
import { getMediaImageStyle } from "shared/util/style";
import { useItem } from "./db.js";

/** Load a reward by its `rid` and get the style properties for it. */
export function useRewardStyle(id: string | undefined): CustomCSSProperties | undefined {
	const item = useItem("reward", id);
	return item?.exists === true ? getRewardStyle(item.data) : undefined;
}

/** Get the style properties for a reward. */
export function getRewardStyle({ image, hue }: { image: string | null; hue: number | null }): CustomCSSProperties | undefined {
	return getMediaImageStyle(image, hue);
}
